import { writeToStorage } from './writeToStorage';

/** Call when the user submits or dismisses the survey. Starts the 30-day hard cooldown. */
export const recordCsatInteracted = (): void => {
	const now = Date.now();
	writeToStorage({
		lastShownAt: now,
		lastInteractedAt: now,
		qualifyingConversations: 0,
	});
};
